import { createReducer, on } from '@ngrx/store';
import { loginStoreData } from '../../core/models/Interfaces/login';
import {
  loginFailed,
  loginReceived,
  loginRequest,
} from '../actions/loginAction';

const initialState: loginStoreData = {
  isFetchingLogin: false,
  loginData: null,
  loginFailedData: null,
};

export const loginReducer = createReducer(
  initialState,
  on(loginRequest, (state) => {
    return { ...state, isFetchingLogin: true };
  }),
  on(loginReceived, (state, { data }) => {
    localStorage.setItem('userData', JSON.stringify(data));
    localStorage.setItem('isLoggedIn', 'true');
    localStorage.setItem('sessionHash', JSON.stringify(data.sessionHash));
    return {
      ...state,
      isFetchingLogin: false,
      loginData: data,
      loginFailedData: null,
    };
  }),
  on(loginFailed, (state, { data }) => {
    return {
      ...state,
      isFetchingLogin: false,
      loginData: null,
      loginFailedData: data,
    };
  }),
);
